module.exports = __webpack_public_path__ + "static/media/box-full.c53b99e9.svg";